import { BookOpen, Cog, Home, Receipt } from "lucide-react";

export const menuItems = [
    {
        href: "/dashboard",
        label: "Tableau de bord",
        icon: <Home className="h-5 w-5" />
    },

    {
        label: "Services",
        icon: <Cog className="h-5 w-5" />,
        permissions: [],
        href: "/dashboard/services",
    },

    {
        label: "Disponibilités",
        icon: <Cog className="h-5 w-5" />,
        permissions: [],
        href: "/dashboard/availabilities",
    },

    {
        label: "Rendez-vous",
        icon: <Cog className="h-5 w-5" />,
        permissions: [],
        href: "/dashboard/appointments",
    },

    {
        label: "Formations",
        icon: <BookOpen className="h-5 w-5" />,
        permissions: [],
        href: "/dashboard/formations",
    },

    {
        label: "Ventes",
        icon: <Receipt className="h-5 w-5" />,
        permissions: [],
        href: "/dashboard/orders",
    },
];
